
import {
  getInstaWPTimeRemainingInSeconds,
  formatInstaWPTimeRemaining,
  handleClaimSite
} from "@/futurelayer/connector/util";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({})
export default class TopNavNotificationBarDeletionWarning extends Vue {
  intervalId: number | null = null;
  timeRemainingInSeconds: null | number = null;

  get formattedTime(): string | false {
    if (!this.timeRemainingInSeconds) return false;
    return formatInstaWPTimeRemaining(this.timeRemainingInSeconds, true);
  }

  handleClaimSite() {
    handleClaimSite();
  }

  mounted() {
    this.timeRemainingInSeconds = getInstaWPTimeRemainingInSeconds();

    this.intervalId = window.setInterval(() => {
      this.timeRemainingInSeconds = getInstaWPTimeRemainingInSeconds();
    }, 1000);
  }

  beforeDestroy() {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
    }
  }
}
